import { createApp } from 'vue/dist/vue.esm-bundler.js'
{
  const appConfig = {
    data(){
      return {
        loading: true,
        selectedCategoryId: '',
        selectedAction: '',
        search: '',
        page: 1,
        maxPages: 1,
        nominees: []
      }
    },
    mounted(){
      // set from url
      const urlcat = window.coolHelperFunctions.getURLParam('category-id')
      if(urlcat){
        this.selectedCategoryId = urlcat
      }

      // then submit form
      this.submitForm(true)
    },
    methods: {
      setPage(val){
        this.page = parseInt(val)
        this.submitForm(false)
      },
      submitForm(resetPage){
        if(resetPage){
          this.page = 1
        }
        this.loading = true
        window.coolHelperFunctions.coolAjax({
          action: 'fetch_judge_nominees',
          category_id: this.selectedCategoryId,
          view_action: this.selectedAction,
          search: this.search,
          page: this.page
        }, json => {
          this.loading = false
          this.nominees = json.nominees
          this.maxPages = json.max_pages
        }, err => {
          alert(err)
        })
      }
    }
  }

  function initApp(){
    const els = document.querySelectorAll('.rose-judge-voting-app--listing')
    if(els.length){
      els.forEach(el => {
        const app = createApp(appConfig)
        app.mount(el)
      })
    }
  }

  initApp()
}